import React from 'react';
import './LoadingState.css';

const LoadingState = React.memo(() => {
  return (
    <div className="network-loading">
      <div className="spinner"></div>
      <p>Loading network tree...</p>
    </div>
  );
});

LoadingState.displayName = 'LoadingState';

export default LoadingState;

